import { IGame } from './game.interfaces';

export enum TAB_SECTION {
  LOBBY = 'lobby',
  FAVOURITES = 'favourites',
  RECOMEMENDATION = 'recommendation',
  RECENT = 'recent',
  HOT = 'hot',
  NEW = 'new',

  SLOTS = 'slots',
  TABLE = 'table',
  DICE = 'dice',
  CRASH = 'crash',
  ROULETTE = 'roulette',
  POKER = 'poker',
  BLACKJACK = 'blackjack',
  BACCARAT = 'baccarat',
  CARD = 'card',
  BINGO = 'bingo',
  LOTTERY = 'lottery',

  BUY_IN = 'buyIn',
  VOLATILITY = 'volatility',
  LIVE = 'live',
}
export interface ILobbySection {
  section: TAB_SECTION;
  type: 'GAME_CATEGORY' | 'GAME_EVENT';
  label: string;
  icon?: string;
  games: IGame[];
}
export interface ITabSection {
  tab: TAB_SECTION;
  label: string;
  icon: string;
  sections?: TAB_SECTION[];
  background?: string;
  number?: number;
}
